export default __webpack_public_path__ + "static/media/751.772e4498.gif";